module.exports = __webpack_public_path__ + "static/media/Logo_latuque.2c46bc9b.png";